
import HttpRequest from '../HttpRequest';
import ENDPOINTS from './constants';

export default class FileManagementApi extends HttpRequest {
  
  importProductsFile({ file, uploadType }) {
    const bodyFormData = new FormData();
    bodyFormData.set('file', file);
    bodyFormData.set('upload_type', uploadType);

    return this.call(ENDPOINTS.UPLOAD, {
      method: 'POST',
      data: bodyFormData,
    });
  }

  getUploadLogs(uploadTypes) {
    const queryParams = new URLSearchParams();
    uploadTypes.forEach(type => queryParams.append("upload_type", type));

    return this.call(`${ENDPOINTS.UPLOAD_LOGS}?${queryParams.toString()}`);
  }

  getInventoryLogs() {
    return this.getUploadLogs(["inventory_full", "inventory_partial"]);
  }

  getProductsLogs() {
    return this.getUploadLogs(["products_add", "products_edit","products_delete"]);
  }
}
 


  


export { ENDPOINTS };
